module.exports = __webpack_public_path__ + "static/img/cont37_03.995e849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_03.jpg
// module id = Azib
// module chunks = 0